<template>
  <Stack class="ask-intro">
    <AskIcon variant="logo" />

    <Title class="ask-intro-title">
      <p>Hi <strong class="ask-intro-name">{{ advisorStore.advisor?.name }}</strong>,</p>
      <p>how can I help?</p>
    </Title>
  </Stack>
</template>

<script setup>
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { Stack, Title } from '@stakeui';

import AskIcon from './AskIcon.vue';

const advisorStore = useAdvisorStore();
</script>

<style scoped>
.ask-intro {
  padding: 6rem 2rem;
  text-align: center;
  align-items: center;
}

.ask-intro-title {
  color: var(--stk-text-normal);
  font-weight: 500;
}

.ask-intro-name {
  color: var(--stk-text-strong);
  font-weight: 600;
}
</style>

<style>
.footer {
  display: none;
}
</style>
